module.exports = __webpack_public_path__ + "static/service_bg2@2x-5bbdf05076562085a6c7054d7d9270f2.png";